export default "__VITE_ASSET__5KD2F5hw__"